import React, { lazy, Suspense } from "react";
import MainCharts from "../MainDashBoard/Dashboard/dashboardCharts/MainCharts";
// import MainLists from "../MainDashBoard/Dashboard/dashboardLists/MainLists";
import MainCards from "../MainDashBoard/Dashboard/dashboardStatCards/MainCards";
const MainTables = lazy(() =>
  import("../MainDashBoard/Dashboard/dashboardTables/MainTables")
);

const DashboardPage = () => {
  return (
    <div className="mt-10 mx-2">
      <MainCards />
      <MainCharts />
      <Suspense fallback={<h1>Loading…</h1>}>
        <MainTables />
      </Suspense>
      {/* <MainLists /> */}
    </div>
  );
};

export default DashboardPage;
